import { render, staticRenderFns } from "./bussnessDetail.vue?vue&type=template&id=3cdae194&scoped=true"
import script from "./bussnessDetail.vue?vue&type=script&lang=ts"
export * from "./bussnessDetail.vue?vue&type=script&lang=ts"
import style0 from "./bussnessDetail.vue?vue&type=style&index=0&id=3cdae194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdae194",
  null
  
)

export default component.exports